import * as types from './types';

const INITIAL_STATE = {
  ingredientGroups: [],
  ingredientSources: [],
  loading: false,

  error: null,

  writeSuccessful: false,
  deleteSuccessful: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_INGREDIENT_GROUPS_LOADING:
    case types.WRITE_INGREDIENT_GROUPS_LOADING:
    case types.DELETE_INGREDIENT_GROUP_LOADING:
    case types.GET_INGREDIENT_SOURCES_LOADING:
      return {
        ...state,
        loading: action.payload,
        deleteSuccessful: false,
        writeSuccessful: false,
      };
    case types.DELETE_INGREDIENT_GROUP_ERROR:
    case types.WRITE_INGREDIENT_GROUPS_ERROR:
    case types.GET_INGREDIENT_GROUPS_ERROR:
    case types.GET_INGREDIENT_SOURCES_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.DELETE_INGREDIENT_GROUP_SUCCESS:
      return {
        ...state,
        ingredientGroups: action.payload,
        deleteSuccessful: true,
      };
    case types.WRITE_INGREDIENT_GROUPS_SUCCESS:
      return {
        ...state,
        ingredientGroups: action.payload,
        writeSuccessful: true,
      };
    case types.GET_INGREDIENT_GROUPS_SUCCESS:
      return {
        ...state,
        ingredientGroups: action.payload,
      };
    case types.GET_INGREDIENT_SOURCES_SUCCESS:
      return {
        ...state,
        ingredientSources: action.payload,
      };
    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/ingredientGroup/reducer.js